export default {
  title: "الدعم",
  rules: {
    note: "قبل إرسال الطلب، يُرجى الاطلاع على القواعد:",
    rule_1: "1. راجع أولاً قسم {faq} (الأسئلة الشائعة) — قد تكون الإجابة موجودة هناك بالفعل.",
    rule_2: "2. في حال وجود مشاكل في الدفع، يرجى إرفاق تفاصيل المعاملة (التاريخ، المبلغ، طريقة الدفع، لقطات الشاشة).",
    rule_3: "3. في حال وجود مشاكل في تنزيل الملفات، يرجى ذكر روابط هذه الملفات.",
    rule_4: "4. للاستفسارات المتعلقة بحقوق النشر أو أي ملفات أخرى تنتهك القواعد، تواصل على: {email}",
    rule_5: "5. للتعاون، وبرامج الشراكة، والإعلانات، وغيرها من العروض التجارية، راسلنا على: {email}",
    rule_6: "6. قد يستغرق الرد من 12 ساعة إلى يومي عمل، حسب تعقيد الطلب وحجم ضغط فريق الدعم.",
    rules: "القواعد",
    faq: "الأسئلة الشائعة"
  },
  messages: {
    note: "*يتم عرض آخر {count} رسالة",
    you: "أنت",
    support: "الدعم",
    autoanswer_subject_is_over: "تم إغلاق المحادثة لأنه تم حل مشكلتك.\nشكراً لتواصلك مع فريق الدعم."
  },
  inputs: {
    message: {
      placeholder: "اكتب سؤالك"
    },
    attachments: {
      btn: "{text} {formats}",
      attach_file: "إرفاق ملف",
      attached_files: "الملفات المرفقة:"
    }
  },
  errors: {
    generic: "خطأ",
    invalid_file_type: "تنسيق ملف غير مدعوم.",
    max_file_size_limit: "الملف كبير جدًا. اختر ملفًا أصغر.",
    filename_too_long: "اسم الملف طويل جدًا",
    filename_invalid_chars: "اسم الملف يحتوي على أحرف غير صالحة"
  },
  btn: {
    send: "إرسال"
  }
};
